import { render, staticRenderFns } from "./new-password.vue?vue&type=template&id=bd97a06a&scoped=true"
import script from "./new-password.vue?vue&type=script&lang=js"
export * from "./new-password.vue?vue&type=script&lang=js"
import style0 from "./new-password.vue?vue&type=style&index=0&id=bd97a06a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd97a06a",
  null
  
)

export default component.exports